import { requestApi } from './helper';

export const SAVE_DESTINATION_LIST = 'SAVE_DESTINATION_LIST';
export const INVALIDATE_DESTINATION_LIST = 'INVALIDATE_DESTINATION_LIST';
export const INVALIDATE_DESTINATION = 'INVALIDATE_DESTINATION';
export const SAVE_DESTINATION = 'SAVE_DESTINATION';
export const SAVE_SERVICE_SITE = 'SAVE_SERVICE_SITE';

export const saveDestinationList = destinationList => (
  { type: SAVE_DESTINATION_LIST, destinationList }
);
export const invalidateDestinationList = () => ({ type: INVALIDATE_DESTINATION_LIST });
export const invalidateDestination = destinationId => (
  { type: INVALIDATE_DESTINATION, destinationId }
);
export const saveDestination = destination => ({ type: SAVE_DESTINATION, destination });
export const saveServiceSite = serviceSite => ({ type: SAVE_SERVICE_SITE, serviceSite });

export const requestDestinationList = (pageNo, limit, selectedCustomers = [], selectedEndCustomer, searchTerm) => requestApi(`/destinations?servicesites=true&ordered=true&limit=${limit}&page=${pageNo}&customers=${selectedCustomers}&endcustomer=${selectedEndCustomer}&searchTerm=${searchTerm}&source=webui`, null, saveDestinationList);

export const requestDestination = destinationId =>
  requestApi(`/destinations/${destinationId}?ordered=true`, null, saveDestination);

export const requestServiceSite = (serviceSiteId, startDate, endDate, errorCallback, successCallback) =>
  requestApi(`/servicesites/${serviceSiteId}?startDate=${startDate}&endDate=${endDate}`, null, saveServiceSite, errorCallback, successCallback);



// WEBPACK FOOTER //
// ./src/actions/destination.js